import React from 'react'
import Button from '@mui/material/Button'
import { setNotification } from '../../components/ui-widgets/uiWidgetsSlice'
import { useAppDispatch } from '../../../app/hooks'
import { RtkQueryHelper } from '../../../api-services/shared/RtkQueryHelper'
import { type AssetHolderUpdateDto } from '../../../api-schema-types/asset-holdings/AssetHolderCrudDtos'
import RotateLeftIcon from '@mui/icons-material/RotateLeft'
import {
  useLegacyApiResetLegacyKycResultMutation
} from '../../../api-services/asset-holdings/assetHolderApi'

interface ResetKYCComponentProps {
  assetHolder: AssetHolderUpdateDto
}

const ResetKYCComponent = (props: ResetKYCComponentProps): JSX.Element => {
  const dispatch = useAppDispatch()
  const { assetHolder } = props

  const [apiResetKYC] = useLegacyApiResetLegacyKycResultMutation()

  const handleResetKYC = (): void => {
    apiResetKYC({ assetHolderId: assetHolder.assetHolderId })
      .unwrap()
      .then(() => {
        dispatch(setNotification({ open: true, severity: 'success', message: 'Member\'s KYC status has been reset.' }))
      })
      .catch((err) => {
        dispatch(setNotification({ open: true, severity: 'error', message: RtkQueryHelper.mapResponseError(err) }))
      })
  }

  const openConfirmDialog = (): void => {
    const choice = window.confirm(
      'Are you sure you want to reset the Members KYC details?'
    )
    if (choice) {
      handleResetKYC()
    }
  }

  return (
    <React.Fragment>
      <Button
        variant={'outlined'}
        startIcon={<RotateLeftIcon />}
        onClick={openConfirmDialog}
        disabled={assetHolder.latestLegacyKycResult?.status === 'INCOMPLETE'}
      >
        Reset KYC
      </Button>
    </React.Fragment>
  )
}

export default ResetKYCComponent
